import { useEffect } from 'react';
import { Notification, Theme, useToast, useTranslation } from '@nextgen-web-framework/all';
import { formatNumber } from '@nextgen-web-framework/core';

export const ToastMessage = ({
  isBundleConditionMatched,
  finalProductPrice,
}: {
  isBundleConditionMatched: { value: boolean };
  currency?: string;
  finalProductPrice: number;
}): JSX.Element => {
  const { addToast, deleteToast } = useToast();
  const t = useTranslation();
  const label = t('product.composite.bundlePriceUpdate.label');

  useEffect(() => {
    const id = 'price_update_toast';
    deleteToast('price_update_toast');
    if (isBundleConditionMatched?.value) {
      addToast({
        id,
        timeout: 5000,
        content: (
          <Notification
            message={`${label} ${formatNumber(finalProductPrice)}`}
            theme={Theme.ACTION}
            onCloseClick={() => deleteToast(id)}
            hasNotificationIcon={false}
          />
        ),
      });
    }
  }, [isBundleConditionMatched, finalProductPrice]);

  return <></>;
};
